<template>
    <u-file-input-outlined-pill v-bind="$attrs" class="v-text-field--label-inner">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-file-input-outlined-pill>
</template>

<script>
import UFileInputOutlinedPill from "@/components/publish/styles/forms/u-file-input-outlined-pill.vue";

export default {
    props: {},
    components: {
        UFileInputOutlinedPill,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
